import { App } from "@/app";
import State from "@lib/hey";
import { Core } from "@unseenco/taxi";
import { Transition } from "@lib/page-transitions";
import { Scroll } from "@lib/scroll";
import { Resize } from "@lib/subs";
import {
  createCycles,
  runDestroy,
  runMount,
  runPageOut,
  runPageIn,
} from "@/modules/_";
import { inAnim, introAnimation, outAnim } from "@/utils/introAnimation";

const PAGES_CONFIG = {
  links: "a:not([data-taxi-ignore]):not([href*='page']):not([href*='&page']):not([href*='?_page']):not([href*='&_page'])",
  removeOldContent: true,
  allowInterruption: false,
  bypassCache: false,
};

export interface TransitionParams {
  from?: Element | HTMLElement;
  to?: Element | HTMLElement;
  trigger: HTMLAnchorElement;
  wrapper: HTMLElement | any;
  destination?: string;
}

export class _Pages extends Core {
  constructor() {
    super({
      ...PAGES_CONFIG,
      transitions: {
        default: Transition,
      },
    });

    createCycles();
    runMount();

    // Ensure init() completes before runPageIn()
    (async () => {
      await this.init();
      runPageIn();
    })();
  }

  async init() {
    await introAnimation()
  }

  async transitionOut({ from, trigger }: TransitionParams) {

    await outAnim()
    await Promise.allSettled([
      await runPageOut(),
      // ...
    ]);

    runDestroy();
    Scroll.toTop();
  }

  async transitionIn({ to, trigger }: TransitionParams) {
    createCycles();
    Scroll.resize();
    Resize.update();

    // State.PAGE = to;


    runMount();

    await inAnim()

    await Promise.allSettled([
      await runPageIn(),
      // ...
    ]);

  }
}

export const Pages = new _Pages();
